import { css } from '@repo/pandacss/styled-system/css';
import { AdvertisingDisclosureTooltipContent } from './AdvertisingDisclosureTooltipContent';

export function AdvertisingDisclosureContent() {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        columnGap: '4',
        rowGap: '4',
        marginBottom: '1',
      })}
    >
      <h3 className={css({ color: 'primary', fontWeight: 'bold', textStyle: 'textLargeBold' })}>
        You&apos;re our first priority.
        <br />
        Every time.
      </h3>
      <AdvertisingDisclosureTooltipContent />
    </div>
  );
}
